import { lazy } from "react";

export const loadCandidateProcessPage = () => import("../../public/process/process");
const CandidateProcessPage = lazy(loadCandidateProcessPage);
const JobDescriptionsSectionsCategoriesPage = lazy(
  () => import("../../administrator/candidate-sourcing/job-description-sections-categories/job-descriptions-sections-categories")
);
const JobDescriptionsBoardsPage = lazy(() => import("../../administrator/candidate-sourcing/job-desc-boards/job-description-boards"));
const ProactiveSourcing = lazy(() => import("../../retained-legacy/proactive-sourcing/proactive-sourcing"));
const EditServiceRedirect = lazy(() => import("./legacy-route-adapters/edit-service-redirect"));
const ServiceAssessmentPage = lazy(() => import("../../retained-legacy/service-assessment/service-assessment"));
const PersonVideoSharingPage = lazy(() => import("../../recruitment/person-videos/person-video-sharing"));

const LoginPage = lazy(() => import("../../../components/login/login"));
const NotFoundPage = lazy(() => import("../../../components/shared/not-found/not-found"));
const TermsRedirectPage = lazy(() => import("../../../components/terms/terms"));
const QuickApplyPublicPage = lazy(() => import("../../quick-apply-web-public/quick-apply-public-page"));
const QuickApplyVerificationPublicPage = lazy(() => import("../../quick-apply-web-public/quick-apply-verification-public-page"));
const ProcessEnrollmentPage = lazy(() => import("../../public/process/enrollment/process-enrollment"));
const ProcessPhaseRedirectPage = lazy(() => import("../../public/process/redirect/process-phase-redirect"));
const AdminSettings = lazy(() => import("../../../components/administrator/admin-settings/admin-settings"));
const AdministratorProcessTemplatesPage = lazy(() => import("../../administrator/manage-templates/manage-templates"));
const FeaturesConfiguration = lazy(() => import("../../../components/administrator/features-configuration/features-configuration"));
const AdministratorTermsPage = lazy(() => import("../../../components/administrator/terms/terms"));
const CookieBannerPage = lazy(() => import("../../../components/administrator/cookie-banner/cookie-banner-config"));
const AdministratorActivityLogsPage = lazy(() => import("../../../components/administrator/activity-logs/activity-logs"));
const UserManagementLogsPage = lazy(() => import("../../../components/administrator/user-management-logs/user-management-logs"));
const HealthyPage = lazy(() => import("../../../components/healthy/healthy"));
const CammioInterviewRedirectPage = lazy(() => import("../../public/process/redirect/cammio-interview-redirect"));
const AdministratorMailsPage = lazy(() => import("../../../components/administrator/email-notifications/email-notifications"));
const AdministratorClientsPage = lazy(() => import("../../administrator/clients/clients"));
const AdministratorLocalClientsPage = lazy(() => import("../../../components/administrator/local-clients/local-clients"));
const AdministratorClientsStatsPage = lazy(() => import("../../administrator/clients-stats/clients-stats"));
const AdministratorRecruiterStatsPage = lazy(() => import("../../../components/administrator/recruiter-stats/recruiter-stats"));
const ProcessFunnelingRedirect = lazy(() => import("./legacy-route-adapters/process-funneling-redirect"));
const ExtraLiveRedirectPage = lazy(() => import("../../../components/extra-live-redirect/extra-live-redirect"));
const MultiCandidateEventRedirectPage = lazy(() => import("../../public/process/redirect/multi-candidate-event-redirect"));
const AdministratorOfferTemplatesPage = lazy(() => import("../../../components/administrator/offer-templates/offer-templates"));
const AdministratorXpertCatalogPage = lazy(() => import("../../../components/administrator/xpert-catalog/xpert-catalog"));
const AdministratorGlobalCompetencyFrameworkSkillPage = lazy(() => import("../../../components/administrator/xpert-global-competency-framework-skill/xpert-global-competency-framework-skill"));
const AdministratorReferenceCheckLibraryPage = lazy(() => import("../../../components/administrator/reference-check-library/reference-check-library"));
const AdministratorPositionPage = lazy(() => import("../../../components/administrator/position/position"));
const AdministratorContractTypePage = lazy(() => import("../../../components/administrator/contract-type/contract-type"));
const AdministratorScreeningQuestionTypesPage = lazy(() => import("../../../components/administrator/screening-question-types/screening-question-types"));
const AdministratorVideoTypesPage = lazy(() => import("../../../components/administrator/video-types/video-types"));
const EnrollmentConfirmationPage = lazy(() => import("../../public/process/enrollment/confirmation/enrollment-confirmation"));
const AdministratorVideoQuestionsLibraryPage = lazy(() => import("../../administrator/video-questions/video-questions"));
const JobListingPage = lazy(() => import("../../../components/candidate-sourcing-ui/job-desc-listing/job-desc-listing"));
const JobPostingPage = lazy(() => import("../../../components/candidate-sourcing-ui/job-desc-posts-listing/job-desc-posts-listing"));
const JobDescription = lazy(() => import("../../../components/candidate-sourcing-ui/job-description/job-description-ui"));
const JobDescriptionDetails = lazy(() => import("../../sourcing/job-description/job-description-details-route"));
const PDFJobDescriptionPage = lazy(() => import("../../candidate-sourcing-ui/job-description/pdf-job-description/pdf-job-description"));
const CandidateUnsubscribePage = lazy(() => import("../../public/process/enrollment/unsubscribe/candidate-unsubscribe"));
const RecruiterPortalPage = lazy(() => import("../../../components/recruiter-portal/recruiter-portal"));
const AdministratorTenantScreeningAttributesPage = lazy(() => import("../../../components/administrator/tenant-screening-attributes/tenant-screening-attributes"));
const AdministratorGlobalScreeningAttributesPage = lazy(() => import("../../../components/administrator/global-screening-attributes/global-screening-attributes"));
const AdministratorGlobalCobrandsPage = lazy(() => import("../../../components/administrator/global-cobrands/global-cobrands"));
const AdministratorGlobalExternalSystems = lazy(() => import("../../administrator/global-external-systems/external-systems/external-systems"));
const AdministratorGlobalOperationsComponent = lazy(() => import("../../administrator/global-external-systems/operations/operations"));
const AdministratorExternalSystemOperationTenant = lazy(() => import("../../administrator/global-external-systems/external-systems-operations-tenant/external-systems-operation-tenant"));
const AdministratorLinks = lazy(() => import("../../administrator/links/links"));
const TenantEmails = lazy(() => import("../../../components/administrator/tenant-emails/tenant-emails"));
const AdministratorMyaEvents = lazy(() => import("../../../components/administrator/mya-events/mya-events"));
const AdministratorProactiveSourcing = lazy(() => import("../../retained-legacy/proactive-sourcing/admin/proactive-sourcing-admin"));
const AdministratorUploadJDManually = lazy(() => import("../../administrator/upload-jd-manually-tool/upload-jd-manually-tool"));
const JobDescriptionTemplatesListing = lazy(() => import("../../candidate-sourcing-ui/job-desc-templates/listing/job-desc-templates-listing"));
const JobDescriptionTemplateUI = lazy(() => import("../../candidate-sourcing-ui/job-desc-templates/job-desc-template"));
const ManageSmsCandidateStatus = lazy(() => import("../../administrator/sms/candidate-status/candidate-status"));
const ManageBudgets = lazy(() => import("../../administrator/manage-budgets/manage-budgets"));
const ClientBrand = lazy(() => import("../../../components/administrator/client-brand/client-brand"));
const ConversionRatesReport = lazy(() => import("../../administrator/conversion-rates-report/conversion-rates-report"));
const LoginToken = lazy(() => import("../../login-token/login-token"));
const AdministratorJobDescriptionFields = lazy(() => import("../../administrator/job-description-creation-fields/job-description-creation-fields"));

// New design system pages
const ProcessCreationIntro = lazy(() => import("../../recruitment/processes/new/process-intro"));
const ProcessCreationPhases = lazy(() => import("../../recruitment/processes/edit/process-phases"));
const RecruitmentHome = lazy(() => import("../../recruitment/home/recruitment-home"));
const ProcessDetails = lazy(() => import("../../recruitment/processes/details/process-details"));
const CandidatesDetails = lazy(() => import("../../recruitment/candidates/details/candidate-details"));
const Assessments = lazy(() => import("../../recruitment/services/assessments/assessments"));
const jobDetails = lazy(() => import("../../recruitment/jobs/job-details/job-details"));
const JobCreation = lazy(() => import("../../recruitment/jobs/job-creation/job-creation-form"));
const ServiceDetailNewPage = lazy(() => import("../../recruitment/services/service-details/service-details"));
const PersonDetailsPage = lazy(() => import("../../recruitment/persons/person-details"));
const ShortlistUIPage = lazy(() => import("../../recruitment/processes/shortlist/shortlist-ui"));
const VideoLibraryPage = lazy(() => import("../../video-library/video-library-page"));
const ServiceCreationIntro = lazy(() => import("../../recruitment/services/new/service-creation-init"));
const ServiceCreation = lazy(() => import("../../recruitment/services/edit/service-creation"));
const Calendars = lazy(() => import("../../calendars/calendars"));
const ComplexCalendar = lazy(() => import("../../calendars/details/complex-calendar"));
const UserProfile = lazy(() => import("../../recruitment/profile/recruiter-profile"));
const RecruitersModulesPage = lazy(() => import("../../administrator/recruiters-modules/recruiters-modules"));
const AdministratorGlobalTagsPage = lazy(() => import("../../administrator/global-tags/global-tags"));
const AdministratorTenantTagsPage = lazy(() => import("../../administrator/tenant-tags/tenant-tags"));
const AdministratorNonAvailabilityCalendarsPage = lazy(() => import("../../administrator/manage-non-availability-calendars/manage-non-availability-calendars"));
const AdministratorTenantVariablesPage = lazy(() => import("../../administrator/tenant-variables/tenant-variables"));
const AdministratorGlobalPersonsPage = lazy(() => import("../../administrator/global-persons/global-persons"));
const AdministratorUsersPage = lazy(() => import("../../administrator/users/users"));
const AdministratorTenantCategoriesPage = lazy(() => import("../../administrator/categories/categories"));
const AdministratorTenantLanguagesPage = lazy(() => import("../../administrator/languages/languages"));
const AdministratorGlobalCategoriesPage = lazy(() => import("../../administrator/global-categories/global-categories"));
const AdministratorManageTenantPage = lazy(() => import("../../administrator/manage-tenant/manage-tenant"));
const AdministratorManageLiterals = lazy(() => import("../../administrator/manage-literals/manage-literals"));
const AdministratorTenantsPage = lazy(() => import("../../administrator/tenants/tenants"));
const AdministratorGlobalSkillsPage = lazy(() => import("../../../components/administrator/global-skills/global-skills"));
const AdministratorTenantSkillsPage = lazy(() => import("../../administrator/skills/skills"));
const AdministratorIndustriesPage = lazy(() => import("../../../components/administrator/industries/industries"));
const AdministratorVideoLibraryPage = lazy(() => import("../../../components/administrator/video-library/video-library"));
const AdministratorScreeningQuestionsLibraryPage = lazy(() => import("../../administrator/screening-questions/screening-questions"));
const AdministratorGlobalBrandsPage = lazy(() => import("../../administrator/global-brands/global-brands"));
const AdministratorManageTagCategoriesPage = lazy(() => import("../../../components/administrator/manage-tag-categories/manage-tag-categories"));
const AdministratorIntegrationErrors = lazy(() => import("../../administrator/integrations-error-logs/integration-error-logs"));
const AdministratorEmailTemplatesPage = lazy(() => import("../../administrator/email-template/email-template"));
const AdministratorEmailTemplatesEditPage = lazy(() => import("../../administrator/email-template/components/email-template-edit"));
const AdministratorEmailTemplatesCreatePage = lazy(() => import("../../administrator/email-template/components/email-template-create"));
const LeadsManagement = lazy(() => import("../../../components/leads-management/leads-management"));
const Leads = lazy(() => import("../../../components/leads-management/leads/leads"));
const LeadsRegistration = lazy(() => import("../../../components/leads-registration/leads-registration"));
const ManageNotificationTemplates = lazy(() => import("../../administrator/manage-notification-templates/manage-notification-templates"));
const Reports = lazy(() => import("../../administrator/admin-reports/reports"));
const Dashboard = lazy(() => import("../../administrator/dashboard/dashboard"));
const LeadsUnsubscribe = lazy(() => import("../../../components/leads-unsubscribe/leads-unsubscribe"));
const AdditionalDocuments = lazy(() => import("../../administrator/additional-documents/additional-documents"));
const CandidateImportFailures = lazy(() => import("../../administrator/candidates-import-failures/candidates-import-failures"));
const SMSTestingTool = lazy(() => import("../../administrator/sms-testing-tool/sms-testing-tool"));
const CacheManager = lazy(() => import("../../administrator/cache-manager/cache-manager"));
const EventsManager = lazy(() => import("../../administrator/events-manager/events-manager"));
const JDBusinessUnitManager = lazy(() => import("../../administrator/business-unit-manager/business-unit-manager"));
const CandidateProcessDetailsLanding = lazy(() => import("../../external-landings/candidate-process-details-landing/candidate-process-details-landing"));
const DeveloperPOCs = lazy(() => import("../../administrator/developer-pocs/developer-pocs"));
const TenantScripts = lazy(() => import("../../administrator/tenant-scripts/tenant-scripts"));
const PDFRenderPage = lazy(() => import("../../public/pdf/pdf-render-page"));
const SharingClientPage = lazy(() => import("../../public/client/ClientSharing"));
const ShortlistClientPage = lazy(() => import("../../public/client/shortlist"));
const ReferencePage = lazy(() => import("../../public/reference/reference"));
const ExtraLiveInterviewPage = lazy(() => import("../../public/extra-live-interview/extra-live-interview"));
const AdministratorLiteralsManagement = lazy(() => import("../../administrator/literals-management/literals-management"));
const TemplateCreationIntro = lazy(() => import("../../recruitment/templates/new/templates-intro"));

// External landings
const ProcessCreationLandingPage = lazy(() => import("../../../components/external-landings/process-creation-landing/process-creation-landing"));
const CandidateDetailsLandingPage = lazy(() => import("../../../components/external-landings/candidate-details-landing/candidate-details-landing"));
const ExternalLandingCandidatePage = lazy(() => import("../../../components/external-landings/external-landing-candidate/external-landing-candidate"));
const ExternalLandingPersonServicePage = lazy(() => import("../../external-landings/external-landing-person-service/external-landing-person-service"));
const LandingCandidateQuickApplyPage = lazy(() => import("../../../components/external-landings/candidate-quick-apply-landing/candidate-quick-apply-landing"));
const ProcessDetailsLandingPage = lazy(() => import("../../../components/external-landings/process-details-landing/process-details-landing"));
const ProcessTemplatesLandingPage = lazy(() => import("../../../components/external-landings/process-templates-landing/process-templates-landing"));
const PersonDetailsLandingPage = lazy(() => import("../../../components/external-landings/person-details-landing/person-details-landing"));
const CandidateAttachmentLandingPage = lazy(() => import("../../../components/external-landings/candidate-attachment-landing/candidate-attachment-landing"));
const NewRequisitionLandingPage = lazy(() => import("../../../components/external-landings/new-requisition-landing/new-requisition-landing"));
const LandingPeronsVideoSharingPage = lazy(() => import("../../../components/external-landings/person-video-sharing-landing/person-video-sharing-landing"));
const CandidatePublicLanding = lazy(() => import("../../../components/external-landings/candidate-public-landing/candidate-public-landing"));
const CammioLandingPage = lazy(() => import("../../../components/external-landings/cammio-landing/cammio-landing"));
const JobDescriptionExternalLanding = lazy(() => import("../../../routes/external-landings/job-description-external-landing/job-description-external-landing"));
const JobDescriptionListingExternalLanding = lazy(() => import("../../../routes/external-landings/job-description-listing-external-landing/job-description-listing-external-landing"));
const JobDescriptionListingExternalLandingUser = lazy(() => import("../../../routes/external-landings/job-description-listing-external-landing/job-description-listing-external-landing-user"));
const JobPostingListingExternalLanding = lazy(() => import("../../../routes/external-landings/jop-posting-external-landing/job-posting-listing-external-landing"));
const ProcessesLanding = lazy(() => import("../../../components/external-landings/processes-landing/processes-landing"));
const SMSRedirectLanding = lazy(() => import("../../../components/external-landings/sms-redirecet-landing/sms-redirect-landing"));

const routesObject: any = {
  NOT_FOUND: NotFoundPage,
  JOB_DESCRIPTION: JobDescription,
  JOB_DESCRIPTION_DETAILS: JobDescriptionDetails,
  JOB_DESCRIPTION_PDF_GENERATOR: PDFJobDescriptionPage,
  JOB_DESCRIPTION_BOARDS: JobDescriptionsBoardsPage,
  JOB_LISTING: JobListingPage,
  JOB_POSTING_LISTING: JobPostingPage,
  LEADS_MANAGEMENT: LeadsManagement,
  LEADS_DETAILS: Leads,
  REPORTS: Reports,
  DASHBOARD: Dashboard,
  LEADS_REGISTRATION: LeadsRegistration,
  LEADS_UNSUBSCRIBE: LeadsUnsubscribe,
  RECRUITMENT: RecruitmentHome,
  LOGIN_TOKEN: LoginToken,
  LOGIN: LoginPage,
  CREATE_PROCESS: ProcessCreationIntro,
  CREATE_SERVICE: ServiceCreationIntro,
  CREATE_SERVICE_TEMPLATE: ServiceCreationIntro,
  EDIT_SERVICE: EditServiceRedirect,
  NEW_EDIT_SERVICE: ServiceCreation,
  DETAILS_PROCESS: ProcessDetails,
  EDIT_PROCESS: ProcessCreationPhases,
  SERVICE_DETAIL: ServiceDetailNewPage,
  SERVICE_ASSESSMENT_DETAIL: Assessments,
  SHORTLIST_PAGE: ShortlistUIPage,
  DETAILS_CANDIDATE: CandidatesDetails,
  CANDIDATE_PROCESS: CandidateProcessPage,
  SERVICE_ASSESSMENT: ServiceAssessmentPage,
  SHORTLIST_PUBLIC: ShortlistClientPage,
  QUICK_APPLY_VERIFICATION_WEB_PUBLIC: QuickApplyVerificationPublicPage,
  QUICK_APPLY_WEB_PUBLIC: QuickApplyPublicPage,
  CANDIDATE_WEB_PUBLIC: ProcessEnrollmentPage,
  CANDIDATE_WEB_REDIRECT: ProcessPhaseRedirectPage,
  TERMS: TermsRedirectPage,
  POLICY: TermsRedirectPage,
  MARKETING: TermsRedirectPage,
  ADMINISTRATOR_HOME: AdminSettings,
  ADMINISTRATOR_USERS: AdministratorUsersPage,
  ADMINISTRATOR_TEMPLATES: AdministratorProcessTemplatesPage,
  ADMINISTRATOR_TENANTS: AdministratorTenantsPage,
  ADMINISTRATOR_CATEGORIES: AdministratorTenantCategoriesPage,
  ADMINISTRATOR_VARIABLES: AdministratorTenantVariablesPage,
  ADMINISTRATOR_OFFER_TEMPLATES: AdministratorOfferTemplatesPage,
  ADMINISTRATOR_MANAGE_TAG_CATEGORIES: AdministratorManageTagCategoriesPage,
  ADMINISTRATOR_BUDGETS: ManageBudgets,
  ADMINISTRATOR_LANGUAGES: AdministratorTenantLanguagesPage,
  ADMINISTRATOR_SERVICES: FeaturesConfiguration,
  ADMINISTRATOR_TERMS: AdministratorTermsPage,
  ADMINISTRATOR_COOKIE_BANNER: CookieBannerPage,
  ADMINISTRATOR_ACTIVITY: AdministratorActivityLogsPage,
  USER_MANAGEMENT_LOGS: UserManagementLogsPage,
  ADMINISTRATOR_INDUSTRIES: AdministratorIndustriesPage,
  HEALTHY: HealthyPage,
  ADMINISTRATOR_GLOBAL_CATEGORIES: AdministratorGlobalCategoriesPage,
  ADMINISTRATOR_MAILJET: AdministratorMailsPage,
  ADMINISTRATOR_SKILLS: AdministratorGlobalSkillsPage,
  ADMINISTRATOR_LOCAL_SKILLS: AdministratorTenantSkillsPage,
  ADMINISTRATOR_TENANT_CONVERSION_RATES_REPORT: ConversionRatesReport,
  RECRUITER_PROFILE: UserProfile,
  LANDING_INTERVIEW: CammioInterviewRedirectPage,
  LANDING_SMS_REDIRECT: SMSRedirectLanding,
  ADMINISTRATOR_CLIENTS: AdministratorClientsPage,
  ADMINISTRATOR_BRANDS: AdministratorGlobalBrandsPage,
  ADMINISTRATOR_COBRANDS: AdministratorGlobalCobrandsPage,
  ADMINISTRATOR_LOCAL_CLIENTS: AdministratorLocalClientsPage,
  SHARING_CANDIDATE_WEB_PUBLIC: SharingClientPage,
  ADMINISTRATOR_LOCAL_CLIENTS_STATS: AdministratorClientsStatsPage,
  LIVE_INTERVIEW: ExtraLiveInterviewPage,
  ADMINISTRATOR_LOCAL_RECRUITER_STATS: AdministratorRecruiterStatsPage,
  PROCESS_FUNNELING: ProcessFunnelingRedirect,
  EXTRA_LIVE_REDIRECT: ExtraLiveRedirectPage,
  MCE_REDIRECT: MultiCandidateEventRedirectPage,
  ADMINISTRATOR_TAGS: AdministratorGlobalTagsPage,
  ADMINISTRATOR_MANAGE_TENANT: AdministratorManageTenantPage,
  ADMINISTRATOR_XPERT_CATALOG: AdministratorXpertCatalogPage,
  CANDIDATE_WEB_CONFIRMATION: EnrollmentConfirmationPage,
  ADMINISTRATOR_GLOBAL_COMPETENCY_FRAMEWORK_SKILL: AdministratorGlobalCompetencyFrameworkSkillPage,
  ADMINISTRATOR_SCREENING_QUESTIONS_LIBRARY: AdministratorScreeningQuestionsLibraryPage,
  ADMINISTRATOR_REFERENCE_CHECK_LIBRARY: AdministratorReferenceCheckLibraryPage,
  ADMINISTRATOR_POSITION: AdministratorPositionPage,
  ADMINISTRATOR_CONTRACT_TYPE: AdministratorContractTypePage,
  ADMINISTRATOR_SCREENING_QUESTION_TYPES: AdministratorScreeningQuestionTypesPage,
  ADMINISTRATOR_VIDEO_TYPES: AdministratorVideoTypesPage,
  ADMINISTRATOR_VIDEO_LIBRARY: AdministratorVideoLibraryPage,
  ADMINISTRATOR_LOCAL_QUESTIONS: AdministratorVideoQuestionsLibraryPage,
  ADMINISTRATOR_TENANT_TAGS: AdministratorTenantTagsPage,
  ADMINISTRATOR_TENANT_SCREENING_ATTRIBUTES: AdministratorTenantScreeningAttributesPage,
  ADMINISTRATOR_SCREENING_ATTRIBUTES: AdministratorGlobalScreeningAttributesPage,
  ADMINISTRATOR_CALENDAR: Calendars,
  ADMINISTRATOR_HOLIDAY_CALENDAR: AdministratorNonAvailabilityCalendarsPage,
  ADMINISTRATOR_TENANT_EMAILS: TenantEmails,
  ADMINISTRATOR_PERSONS: AdministratorGlobalPersonsPage,
  EMAIL_TEMPLATE: AdministratorEmailTemplatesPage,
  EMAIL_TEMPLATE_EDIT: AdministratorEmailTemplatesEditPage,
  EMAIL_TEMPLATE_CREATE: AdministratorEmailTemplatesCreatePage,
  CALENDARS_PAGE: Calendars,
  VIDEO_LIBRARY_PAGE: VideoLibraryPage,
  CANDIDATE_WEB_UNSUBSCRIBE: CandidateUnsubscribePage,
  PROCESS_CREATION_LANDING: ProcessCreationLandingPage,
  CANDIDATE_QUICK_APPLY: LandingCandidateQuickApplyPage,
  PROCESS_DETAILS_LANDING: ProcessDetailsLandingPage,
  PROCESS_TEMPLATES_LANDING: ProcessTemplatesLandingPage,
  PERSON_DETAILS_LANDING: PersonDetailsLandingPage,
  CANDIDATE_ATTACHMENT_LANDING: CandidateAttachmentLandingPage,
  CANDIDATE_DETAILS_LANDING: CandidateDetailsLandingPage,
  EXTERNAL_LANDING_CANDIDATE_DETAILS: ExternalLandingCandidatePage,
  EXTERNAL_LANDING_PERSON_SERVICE_DETAILS: ExternalLandingPersonServicePage,
  CANDIDATE_PUBLIC_LANDING: CandidatePublicLanding,
  CAMMIO_LANDING: CammioLandingPage,
  PROCESSES_LANDING: ProcessesLanding,
  JOB_DETAILS: jobDetails,
  JOB_DETAILS_PROCESS: ProcessDetails,
  JOB_DETAILS_PROCESS_CANDIDATE: CandidatesDetails,
  CANDIDATE_DETAILS_PROCESS: CandidatesDetails,
  CANDIDATE_DETAILS: PersonDetailsPage,
  JOB_EDIT: JobCreation,
  JOB_NEW: JobCreation,
  NEW_REQUISITION_LANDING: NewRequisitionLandingPage,
  RECRUITER_PORTAL: RecruiterPortalPage,
  JOB_DESCRIPTION_TEMPLATES: JobDescriptionTemplatesListing,
  JOB_DESCRIPTION_TEMPLATE: JobDescriptionTemplateUI,
  JOB_DESCRIPTION_LOCAL_TEMPLATE: JobDescriptionTemplateUI,
  JOBDESCRIPTION_CREATION_LANDING: JobDescriptionExternalLanding,
  JOBDESCRIPTION_LISTING_EXTERNAL_LANDING: JobDescriptionListingExternalLanding,
  JOBDESCRIPTION_LISTING_EXTERNAL_LANDING_USER: JobDescriptionListingExternalLandingUser,
  JOBPOSTING_LISTING_EXTERNAL_LANDING: JobPostingListingExternalLanding,
  REFERENCE_CHECK: ReferencePage,
  ADMINISTRATOR_MANAGE_EXTERNAL_SYSTEMS: AdministratorGlobalExternalSystems,
  ADMINISTRATOR_MANAGE_OPERATIONS: AdministratorGlobalOperationsComponent,
  ADMINISTRATOR_MANAGE_TENANT_SYSTEM_OPERATION: AdministratorExternalSystemOperationTenant,
  ADMINISTRATOR_MANAGE_LINKS: AdministratorLinks,
  ADMINISTRATOR_MANAGE_INTEGRATION_ERRORS: AdministratorIntegrationErrors,
  ADMINISTRATOR_MYA_EVENTS: AdministratorMyaEvents,
  ADMINISTRATOR_GLOBAL_PROACTIVE_SOURCING: AdministratorProactiveSourcing,
  ADMINISTRATOR_UPLOAD_JD_MANUALLY: AdministratorUploadJDManually,
  ADMINISTRATOR_JOB_DESCRIPTION_FIELDS: AdministratorJobDescriptionFields,
  PROACTIVE_SOURCING: ProactiveSourcing,
  PERSON_VIDEOS_SHARING: PersonVideoSharingPage,
  PERSON_VIDEOS_SHARING_LANDING: LandingPeronsVideoSharingPage,
  ADMINISTRATOR_NOTIFICATION_TEMPLATES: ManageNotificationTemplates,
  ADMINISTRATOR_SMS_CANDIDATES_STATUS: ManageSmsCandidateStatus,
  RECRUITERS_MODULES: RecruitersModulesPage,
  ADMINISTRATOR_CLIENT_BRAND: ClientBrand,
  ADMINISTRATOR_MANAGE_LITERALS: AdministratorManageLiterals,
  CANDIDATE_PROCESS_DETAILS: CandidateProcessDetailsLanding,
  JOB_DESCRIPTION_SECTIONS_CATEGORIES: JobDescriptionsSectionsCategoriesPage,
  CALENDARS_DETAILS_PAGE: ComplexCalendar,
  ADMINISTRATOR_CALENDAR_DETAILS: ComplexCalendar,
  USER_PROFILE: UserProfile,
  ADMINISTRATOR_SMS_TESTING_TOOL: SMSTestingTool,
  ADMINISTRATOR_CACHE_MANAGER: CacheManager,
  ADMINISTRATOR_EVENT_MANAGER: EventsManager,
  ADMINISTRATOR_JD_BU_TENANT_MANAGER: JDBusinessUnitManager,
  ADMINISTRATOR_ADDITIONAL_DOCUMENTS: AdditionalDocuments,
  ADMINISTRATOR_DEVELOPER_POCS: DeveloperPOCs,
  ADMINISTRATOR_TENANT_SCRIPTS: TenantScripts,
  ADMINISTRATOR_CANDIDATE_IMPORT_FAILURES: CandidateImportFailures,
  PDF_RENDER_PAGE: PDFRenderPage,
  ADMINISTRATOR_LITERALS_MANAGEMENT: AdministratorLiteralsManagement,
  default: null,
  CREATE_PROCESS_TEMPLATE: TemplateCreationIntro,
  DETAILS_PROCESS_TEMPLATE: ProcessCreationPhases,
  EDIT_PROCESS_TEMPLATE: ProcessCreationPhases,
};

export const getComponentFromRouteId = (routeId: string) => {
  return routesObject[routeId] || null;
};
